import React from "react";

const ArrearsAdvance = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            className="u_fill" fill={fill}
            d="m16.675 5.705 1.298-1.062 1.298 1.036h3.205L18 2l-4.583 3.731h1.351c.636-.026 1.271-.026 1.907-.026ZM27.775 9.955l.027 2.669 3.576 2.928-3.524 2.876-4.582 3.73 6.754 6.608c.45.44.45 1.14 0 1.58-.238.208-.503.337-.82.337-.319 0-.584-.103-.822-.337l-6.887-6.736L18 26.46l-3.523-2.876L7.59 30.32c-.45.441-1.166.441-1.616 0-.45-.44-.45-1.14 0-1.58l6.754-6.607-1.96-1.555-2.57-2.098-3.576-2.928 3.55-2.902c0-.39 0-.83-.026-1.244v-1.373l-6.146 5v17.231C2 33.223 2.795 34 3.775 34h28.45c.98 0 1.775-.777 1.775-1.736v-17.23l-6.225-5.08Z"
        />
        <path
            className="u_fill" fill={fill}
            d="M9.762 13.374c.026 1.451.026 2.747.053 4.38l2.887 2.357c-.026-1.917-.026-3.16-.053-5.519.08-.026.133-.052.212-.077l.106-.026c1.404-.415 2.278-1.322 2.543-2.747 1.855 0 3.444-.026 4.927-.052.398 1.477 1.404 2.436 2.914 2.799.027 2.565.027 3.834.053 5.544l2.861-2.331-.053-4.353v-2.021l-.026-2.125c0-.207-.027-.415-.08-.596-.212-.777-.848-1.296-1.695-1.4-.106 0-.212-.025-.318-.025-.98 0-1.96 0-2.94.026-.822 0-1.616 0-2.437.026h-1.457c-.822 0-1.67.026-2.49.026-1.007 0-1.987.026-2.994.026-.106 0-.212 0-.318.025-.08 0-.159.026-.265.052-.715.182-1.218.648-1.404 1.322-.079.207-.106.466-.106.725 0 .726 0 1.373.027 1.995.026.674.026 1.322.053 1.97Z"
        />
        <path
            className="u_fill" fill={fill}
            d="M17.974 17.65c-1.749.026-3.153 1.4-3.126 3.11 0 .517.132 1.01.37 1.424.371.7 1.034 1.244 1.802 1.477.318.104.636.156.98.156.318 0 .636-.052.927-.156a3.22 3.22 0 0 0 1.828-1.477c.238-.44.37-.933.37-1.477 0-1.71-1.403-3.083-3.151-3.057Z"
        />
    </svg>
);

export default ArrearsAdvance;
